module.exports = __webpack_public_path__ + "static/media/withdrawIcon.764d10f3.svg";